import React, { useState, useEffect, useRef } from 'react';
const PositionsENMobile = () => {
  const [isVisible, setIsVisible] = useState(false);
  const targetRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      },
      { threshold: 0.1 } // Adjust this threshold as needed
    );

    if (targetRef.current) {
      observer.observe(targetRef.current);
    }

    return () => {
      if (targetRef.current) {
        observer.unobserve(targetRef.current);
      }
    };
  }, []);

  return (<>
    <div
      ref={targetRef}
      className={`hot-position ${isVisible ? 'visible' : ''}`}
      tabIndex="0"
    >
      <div className="hot-position-body" style={{textAlign: 'right'}}>
        <span className="hot-position-type-he">הודעה מהאונר</span>
        <h3 style={{fontFamily: "Rubik-Medium"}}>
  העולם כולו נמצא במצוקה בעקבות האיום של הטרור מאז ה-7 באוקטובר וזכויותינו נמצאות בסכנה <br/>
  למרות המצב הנורא הזה, ברית EnbyBase עושה כמיטב יכולתה לספק מקום בטוח לאנשים מהקהילה ה-LGBTQIAN+ ולהגן על המגוון <br/>
  אנו מגנים בתוקף את הטרור של חמאס, שחיסל אזרחים ישראלים אל תשכחו את ההיסטוריה
</h3>


        <p className={isVisible ? '' : 'visible'}>
        
        </p>
      </div>
      <div className="hot-position-footer">
        <button className="rohm-save">
          <img
            alt="save"
            src="https://www.mossad.gov.il/save-white.svg"
          />
        </button>
        <div className="share-div">
          <div className="multi-select-background" />
        </div>
        <a
          href="https://www.mossad.gov.il/positions/12"
        >
          View Position
        </a>
      </div>
    </div></>
  );
};

export default PositionsENMobile;
